import CatalogView from "@/pages/category/components/CatalogView";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function TvCategoryPage() {
  usePageMeta(
    "电视剧 - 日韩欧美影视平台",
    "精选日韩与欧美热播电视剧，覆盖科幻、悬疑、爱情、犯罪等类型，支持按类型、地区、年份与连载状态筛选，追剧更省心。",
    "电视剧,欧美剧,日韩剧,热播剧集,追剧,剧集推荐",
  );

  return (
    <CatalogView
      type="tv"
      title="电视剧"
      breadcrumbLabel="电视剧"
      intro="热播与经典剧集集中呈现。支持按类型、地区、年份以及连载/完结状态筛选，帮你快速找到值得追的好剧。"
    />
  );
}